import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledFollowUpCounterText = styled.span(
    ({theme: {palette, typography}}) => css`
        width: 100%;
        ${typography.textSm};
        color: ${palette.neutral['600']};
        font-weight: 500;
    `
)

export const StyledFollowUpCounterNote = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
        font-weight: 400;
    `
)

export const StyledTreatmentRequestFollowUpItem = styled(Flexbox)<{$isDisabled: boolean}>(
    ({$isDisabled}) => css`
        ${$isDisabled &&
        css`
            pointer-events: none;
            opacity: 0.5;
        `}
    `
)
